module.exports = __webpack_public_path__ + "media/images/weather-icons/fill/haze-day-fda09aa383493051cf53d6aba323ced0.svg";